import React from 'react'
import styles from './TabellaCompatibilita.module.sass'
import { CategoriaNode, TabellaCompatibilitaCategoriaNode } from '@gql/graphql'
import { EditableDescription, EditableTitle, WImage } from '@components/atoms'
import useTrans from '@hooks/useTrans'

interface Props {
  className?: string
  sottoCategoria: CategoriaNode
  tabella: TabellaCompatibilitaCategoriaNode
  variant?: 'default' | 'pdf'
  nextImage?: boolean
}

const TabellaCompatibilita = (props: Props) => {
  const {
    className = '',
    sottoCategoria = undefined,
    tabella = undefined,
    variant = 'default',
    nextImage = false,
  } = props

  const t = useTrans()

  return (
    tabella && (
      <div className={`${styles.root} ${className}`}>
        <div className={`${styles.tabella} ${styles[`tabella--${variant}`]}`}>
          <div className={styles.top}>
            <EditableTitle title={tabella.nome} variant="h3" className={styles.title} />
            <EditableDescription description={tabella.descrizione} className={styles.description} />
          </div>

          <table>
            <thead>
              <tr>
                {variant === 'pdf' && <th className={styles.image} />}
                <th className={styles.name} />
                <th className={styles.codice}>{t('Codice')}</th>
                {sottoCategoria?.tabellaDatiTecnici?.prodotti.map((colonna, index) => (
                  <th key={`header-${index}`} className={styles.prodotto}>
                    {colonna.prodotto.nome}
                  </th>
                ))}
                {tabella?.dati?.[0]?.products?.[0].prodotti?.map((prodotto, index) => (
                  <th key={`header-${index}`} className={styles.prodotto}>
                    {prodotto}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tabella.dati.flatMap((gruppo, gruppoIndex) =>
                gruppo.products.map((prodotto, prodottoIndex) => (
                  <tr key={`prodotto-${gruppoIndex}-${prodottoIndex}`}>
                    {variant === 'pdf' && (
                      <td className={styles.productImage}>
                        {gruppo.image && (
                          <WImage
                            src={gruppo.image}
                            maxWidth={160}
                            maxHeight={160}
                            objectFit="contain"
                            alt={prodotto.nome}
                            next={nextImage}
                          />
                        )}
                      </td>
                    )}
                    <td className={styles.productInfo}>{prodotto.nome}</td>
                    <td className={styles.productInfo}>{prodotto.rif}</td>
                    {prodotto.compatibilita.map((val, valIndex) => (
                      <td
                        key={`val-${gruppoIndex}-${prodottoIndex}-${valIndex}`}
                        className={styles.valoreCompatibilita}
                      >
                        {val}
                      </td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    )
  )
}

export default TabellaCompatibilita
